export const isHuaweiDevice = () => {
  const { userAgent = '' } = window.navigator

  return /huawei/i.test(userAgent) || /honor/i.test(userAgent)
}
